module.exports = __webpack_public_path__ + "img/cta-icon.042a9c2b.svg";